exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verticalSplit { \r\n    border: 1px solid black; \r\n}\r\n\r\n.popupoverlayer .popupdialog {\r\n    left: 20%;\r\n    height: 40%;\r\n    width: 60%;\r\n    margin-left: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/transaction-details/transaction-details.component.css
// module id = ../../../../../src/app/components/transaction-details/transaction-details.component.css
// module chunks = 0